import * as Sentry from "@sentry/react";
import { Button, Container, Content, TextButton } from "@volumental/common";
import { useEffect } from "react";
import type { JSX } from "react";
import { useTranslation } from "react-i18next";
import { Header } from "../../components/accessible-components";

interface GeneralErrorPageProps {
  onClose: () => void;
  onRestart?: () => void;
  errorText: string;
}

export function GeneralErrorPage({ errorText, onClose, onRestart }: GeneralErrorPageProps): JSX.Element {
  const { t } = useTranslation();
  useEffect(() => {
    Sentry.captureMessage(`General error page: ${errorText}`, { level: "error" });
  }, [errorText]);
  return (
    <Container>
      <Header close={onClose} />
      <Content>
        <div className="text-center relative top-1/3">
          <div className="font-normal text-xl leading-6.25">{t("SomethingWentWrong")}</div>
          <TextButton onClick={onRestart} hidden={!onRestart}>
            {t("button.reload")}
          </TextButton>
        </div>
      </Content>
      <div className="flex flex-auto flex-col justify-end mt-2.5 mb-4 mx-6">
        <Button loading={false} type="submit" onClick={onClose}>
          {t("button.done")}
        </Button>
      </div>
    </Container>
  );
}
